import { useEffect, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

// Renders a generated PDF (ArrayBuffer) page-by-page onto canvases, so the
// in-app preview is pixel-identical to the downloaded file — no reliance on
// the browser's PDF plugin.
export default function PdfPreview({ data }) {
  const [pages, setPages] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!data) { setPages([]); return; }
    let cancelled = false;
    (async () => {
      try {
        // copy: pdf.js transfers the buffer to its worker, which would detach ours
        const pdf = await pdfjsLib.getDocument({ data: new Uint8Array(data.slice(0)) }).promise;
        const out = [];
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 1.6 });
          const canvas = document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: canvas.getContext('2d'), canvas, viewport }).promise;
          if (cancelled) return;
          out.push(canvas.toDataURL('image/jpeg', 0.92));
          setPages([...out]);
        }
      } catch (e) {
        console.error('PDF preview render failed:', e);
        if (!cancelled) setError(true);
      }
    })();
    return () => { cancelled = true; };
  }, [data]);

  if (error) return <div className="text-xs text-[#C4727F] p-4">Preview could not be rendered — use Download PDF instead.</div>;
  if (!pages.length) return <div className="text-xs text-[#6B7280] p-4">Rendering preview…</div>;

  return (
    <div className="space-y-4">
      {pages.map((src, i) => (
        <img key={i} src={src} alt={`Page ${i + 1}`} className="w-full rounded-md shadow-md border border-[#E8E6E1] bg-white" />
      ))}
    </div>
  );
}
